import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DeleteForeverSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DeleteForeverSVG;
